// extracted by mini-css-extract-plugin
export default {"root":"JobReel_root__iw6f8","title":"JobReel_title__00RgF","blur":"JobReel_blur__Xssk2"};